import React, { useContext } from 'react';

import { ApplyContext, ApplyStep } from 'context/apply.context';

export const SuccessApplication: React.FC = () => {
  const { setStep } = useContext(ApplyContext);

  return (
    <div className="max-w-[526px] mb-[50px]" data-testid="success-apply">
      <div
        className="p-6 rounded-lg flex flex-col gap-y-4 "
        style={{
          background: 'var(--light-white, #FFF)',
          boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10)'
        }}
      >
        <div
          className="flex w-16 h-16 p-1 justify-center items-center gap-[16px]"
          style={{
            borderRadius: '100px',
            background: 'rgba(37, 165, 73, 0.15)'
          }}
        >
          <img
            src={'/svg/upload-successfully.svg'}
            alt="icon"
            width={48}
            height={48}
          />
        </div>
        <h4 className="text-2xl font-medium">
          Chúc mừng bạn đã gửi hồ sơ ứng tuyển tới <br /> DNSE thành công!
        </h4>
        <p className="text-base font-normal leading-6 self-stretch">
          Trong thời gian chờ đợi, bạn có thể tìm hiểu thêm về chúng tôi <br />
          tại{' '}
          <span>
            <a
              href="/happy-dnse/tin-tuc"
              className="font-medium underline text-brand-300"
            >
              Happy DNSE
            </a>{' '}
          </span>
          nhé!
        </p>
      </div>
      <button
        onClick={() => setStep(ApplyStep.UploadCV)}
        className="mt-[20px] whitespace-nowrap px-6 py-[14px] rounded-[40px] text-center w-full text-base font-medium text-white bg-brand-300 col-span-3"
      >
        Gửi lại hồ sơ
      </button>
    </div>
  );
};
